import CountryService from '../services/CountryService';
import { companyChangeLock } from './userData';

const { country } = CountryService.GetInstance(); 

export default [
  {
    fieldName: 'Line1',
    type: 'text',
    label: 'Street address'
  },
  {
    fieldName: 'Line2',
    type: 'text',
    label: 'Address line 2',
    isRequired: false,
  },
  {
    fieldName: 'City',
    type: 'text',
    label: 'City'
  },
  {
    fieldName: 'Zip',
    type: 'text',
    label: 'Zip'
  },
  {
    fieldName: 'CountyState',
    type: 'text',
    label: 'County / State',
    isRequired: false,
  },
  {
    fieldName: 'Country',
    type: 'select',
    label: 'Country',
    
    options: country ? [
      {
        label: country.name,
        value: country.code
      }
    ] : [],
        disabled: (fieldName: string, fieldValue: any, fieldValues: any[]) => {
      // disable only country, not delivery address country select
      return companyChangeLock(fieldName, fieldValue, fieldValues) && fieldName === 'AddressCountry';
    },
  }
];



// WEBPACK FOOTER //
// ./src/formFields/addressTwoLines.tsx